// Round M — trefwoorden: pure helpers for the result messages and counts.
const n = (count, one, many) => `${count} ${count === 1 ? one : many}`;

export function keywordDate(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString("nl-NL", { day: "numeric", month: "long", timeZone: "Europe/Amsterdam" });
}

export function keywordResultMessage(kw) {
  if (!kw) return "";
  if (kw.existing && !kw.pending) return `Dit trefwoord bestaat al — door ${kw.created_by_name || "een teamlid"}, ${keywordDate(kw.created_at)}`;
  if (kw.pending) return "Vragen worden gemaakt…";
  if (kw.all_deleted) return "Alle vragen zijn verwijderd.";
  if (kw.status !== "done") return "Er konden nu geen vragen gemaakt worden. Probeer het later opnieuw.";
  const count = kw.question_count || 0;
  return kw.live
    ? `${n(count, "vraag staat", "vragen staan")} klaar in de stapel`
    : `${n(count, "vraag gaat", "vragen gaan")} eerst langs een beheerder`;
}

export function keywordCounts(kw) {
  return `${n(kw?.question_count || 0, "vraag", "vragen")} · ${kw?.answered_count || 0} beantwoord`;
}

export function canAnswerHere(q) {
  return !!q?.active && !q?.answered;
}

// Round U — deleting a keyword switches off its live questions nobody answered yet.
export const openQuestionsToDeactivate = (kw) => (kw?.questions || []).filter((q) => q.active && !q.answered).length;

const vragen = (n) => `${n} ${n === 1 ? "vraag" : "vragen"}`;

export const keywordDeleteConfirmText = (word, n) =>
  `Trefwoord '${word}' verwijderen? ${vragen(n)} die nog niemand heeft beantwoord ${n === 1 ? "wordt" : "worden"} uitgezet. Beantwoorde vragen blijven staan.`;

export const keywordDeletedToast = (n) => `Trefwoord verwijderd · ${n} open ${n === 1 ? "vraag" : "vragen"} uitgezet`;

export function keywordRowNote(kw) {
  if (kw?.pending) return "Vragen worden gemaakt…";
  if (kw?.all_deleted) return "Alle vragen zijn verwijderd.";
  if (kw?.status === "done") return keywordCounts(kw);
  return "Nog geen vragen";
}
